import { useTranslation } from 'react-i18next';
import { useDatasetStore } from '@/store/dataset-store';
import { useFiltersStore } from '@/store/filters-store';
import { FilterChip } from './FilterChip';
import { PinnedFilterBar } from './pinned/PinnedFilterBar';

export function FilterBar(): JSX.Element | null {
  const { t } = useTranslation();
  const filters = useFiltersStore((s) => s.filters);
  const removeFilter = useFiltersStore((s) => s.removeFilter);
  const clearFilters = useFiltersStore((s) => s.clearFilters);
  const activeId = useDatasetStore((s) => s.activeDatasetId);

  if (!activeId) return null;

  // D-016: drill-down disabled, but we still show non-drilldown chips.
  const manualFilters = filters.filter((f) => f.source !== 'drilldown');

  return (
    <div className="flex flex-col gap-2">
      {/* Row 1: persistent per-column filter slots */}
      <PinnedFilterBar />

      {/* Row 2: active manual filter chips (only shown if any exist) */}
      {manualFilters.length > 0 && (
        <div
          className="flex flex-wrap items-center gap-2 px-3 py-2 rounded-lg min-h-[40px]"
          style={{
            background: 'var(--color-surface)',
            border: '1px solid var(--color-border)',
          }}
        >
          {/* Breadcrumb / undo for drill-down — hidden while D-016 active */}

          {/* Filter chips */}
          {manualFilters.map((f, i) => (
            <FilterChip
              key={`${f.column}-${JSON.stringify(f.value)}-${i}`}
              filter={f}
              onRemove={() => removeFilter(f.column, f.value)}
            />
          ))}

          {/* Clear all */}
          <button
            type="button"
            onClick={clearFilters}
            className="text-[11px] ml-auto px-2 py-0.5 rounded hover:opacity-80 bg-transparent border-0"
            style={{ color: 'var(--color-danger)' }}
          >
            {t('filters.clearAll')}
          </button>
        </div>
      )}
    </div>
  );
}
